import React from 'react';
import Icon from '../../../components/AppIcon';

const ROIWidget = () => {
  const metrics = [
    {
      id: 1,
      label: 'Churn Reduction',
      value: '47%',
      icon: 'TrendingDown',
      color: 'success',
      description: 'Lower employee turnover in first 90 days'
    },
    {
      id: 2,
      label: 'Productivity Gain',
      value: '3x',
      icon: 'Zap',
      color: 'primary',
      description: 'Faster time to full productivity'
    },
    {
      id: 3,
      label: 'Cost Savings',
      value: '€77.000',
      icon: 'Euro',
      color: 'warning',
      description: 'Annual savings per 100 employees'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      success: 'bg-success/10 text-success border-success/20',
      primary: 'bg-primary/10 text-primary border-primary/20',
      warning: 'bg-warning/10 text-warning border-warning/20'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground">Business Impact</h2>
          <p className="text-sm text-muted-foreground mt-1">Real ROI from structured onboarding</p>
        </div>
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="TrendingUp" size={24} color="var(--color-primary)" strokeWidth={2.5} />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {metrics?.map((metric) => (
          <div
            key={metric?.id}
            className={`rounded-lg border p-4 transition-all duration-200 hover:scale-102 hover:shadow-elevation-1 ${getColorClasses(metric?.color)}`}
          >
            <div className="flex items-start justify-between mb-3">
              <Icon name={metric?.icon} size={28} color="currentColor" strokeWidth={2} />
              <div className="text-right">
                <div className="text-3xl font-bold">{metric?.value}</div>
              </div>
            </div>
            <div className="space-y-1">
              <h3 className="font-semibold text-sm">{metric?.label}</h3>
              <p className="text-xs opacity-80">{metric?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted/20 rounded-lg border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">Enterprise-Ready Solution</p>
            <p className="text-xs text-muted-foreground">
              Based on data from 500+ companies using structured onboarding systems. Results may vary based on company size and implementation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ROIWidget;